<template>
  <div class="operation-item">
    <block-title title="下载模板">
      <a-row class="exportStyle item-content">
        <template v-if="!isWmsSystem">
          <a-col :span="11" :offset="0">
          <div
            :class="typeIndex === WAREHOUSETYPE.WAREHOUSE ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(WAREHOUSETYPE.WAREHOUSE)"
          >
            <img v-if="typeIndex === WAREHOUSETYPE.WAREHOUSE" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">仓下单</p>
            <!-- <a-radio class="exportTitle" :checked="typeIndex === WAREHOUSETYPE.WAREHOUSE ? true : false">纯仓储下单</a-radio> -->
            <p class="skuStyle">
              运输入库、纯入库、纯出库
            </p>
<!--            <div-->
<!--              v-if="!isDischarge"-->
<!--              v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-纯仓储下单导入模板`:`批量导入下单-下载模板-纯仓储下单导入模板`}"-->
<!--              class="batchBtnStyle"-->
<!--               @click="downloadExcelWareHouse('纯仓储下单导入模板', WAREHOUSETYPE.WAREHOUSE)"-->
<!--            >-->
<!--              <img src="@/assets/img/icon/xlsx.png" />-->
<!--              纯仓储下单导入模板-->
<!--              <img class="icon_load" :src="typeIndex === WAREHOUSETYPE.WAREHOUSE ? downloadField : downloads" />-->
<!--            </div>-->
            <div class="flex justify-between">
              <div
                v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓入库单模板`:`批量导入下单-下载模板-仓入库单模板`}"
                :class="{batchBtn: true, isActive: type === WAREHOUSETYPE.STORE_V2}"
                @click="changeType(WAREHOUSETYPE.STORE_V2)"
              >
                仓入库单模板
                <img
                  class="icon_load"
                  :src="typeIndex === WAREHOUSETYPE.WAREHOUSE && type === WAREHOUSETYPE.STORE_V2 ? downloadField : downloads"
                  @click="downloadTemplate('仓入库单模版', WAREHOUSETYPE.STORE_V2, true)"
                />
              </div>
              <div
                v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓出库单模板`:`批量导入下单-下载模板-仓出库单模板`}"
                :class="{batchBtn: true, isActive: type === WAREHOUSETYPE.DELIVER_ONLY_V2}"
                @click="changeType(WAREHOUSETYPE.DELIVER_ONLY_V2)"
              >
                仓出库单模板
                <img
                  class="icon_load"
                  :src="typeIndex === WAREHOUSETYPE.WAREHOUSE && type === WAREHOUSETYPE.DELIVER_ONLY_V2 ? downloadField : downloads"
                  @click="downloadTemplate('仓出库单模版', WAREHOUSETYPE.DELIVER_ONLY_V2, true)"
                />
              </div>
            </div>
          </div>
        </a-col>
        <a-col class="leftStyle" :span="11" :offset="0">
          <div
            :class="typeIndex === WAREHOUSETYPE.TRANSPORT ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(WAREHOUSETYPE.TRANSPORT)"
          >
          <img v-if="typeIndex === WAREHOUSETYPE.TRANSPORT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">仓配一体下单</p>
            <!-- <a-radio class="exportTitle" :checked="typeIndex === WAREHOUSETYPE.TRANSPORT ? true : false">仓配一体下单</a-radio> -->
            <p class="skuStyle">
              出库与运输一体下单
            </p>
<!--            <div-->
<!--              v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓配一体下单导入模板`:`批量导入下单-下载模板-仓配一体下单导入模板`}"-->
<!--              class="batchBtnStyle"-->
<!--               @click="downloadExcelWareHouseTransport('仓配一体下单导入模板', WAREHOUSETYPE.TRANSPORT)"-->
<!--            >-->
<!--              <img src="@/assets/img/icon/xlsx.png" />-->
<!--              仓配一体下单导入模板-->
<!--              <img class="icon_load" :src="typeIndex === WAREHOUSETYPE.TRANSPORT ? downloadField : downloads" />-->
<!--            </div>-->
            <div class="flex justify-between">
              <div
                  v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓配一体下单导入模板`:`批量导入下单-下载模板-仓配一体下单导入模板`}"
                class="no-left"
                :class="{batchBtn: true, isActive: type === WAREHOUSETYPE.DELIVER_TRANSPORT_V2}"
                @click="changeType(WAREHOUSETYPE.DELIVER_TRANSPORT_V2)"
              >
                <img src="@/assets/img/icon/xlsx.png" />
                仓配一体下单导入模版
                <img
                  class="icon_load"
                  :src="typeIndex === WAREHOUSETYPE.TRANSPORT && type === WAREHOUSETYPE.DELIVER_TRANSPORT_V2 ? downloadField : downloads"
                  @click="downloadTemplate('仓配一体下单导入模版', WAREHOUSETYPE.DELIVER_TRANSPORT_V2, true)"
                />
              </div>
<!--              <div-->
<!--                v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓配一体出库单模板`:`批量导入下单-下载模板-仓配一体出库单模板`}"-->
<!--                :class="{batchBtn: true, isActive: type === WAREHOUSETYPE.DELIVER}"-->
<!--                @click="changeType(WAREHOUSETYPE.DELIVER)"-->
<!--              >-->
<!--                仓配一体出库-->
<!--                <img-->
<!--                  class="icon_load"-->
<!--                  :src="typeIndex === WAREHOUSETYPE.TRANSPORT && type === WAREHOUSETYPE.DELIVER ? downloadField : downloads"-->
<!--                  @click="downloadTemplate('仓配一体出库', WAREHOUSETYPE.DELIVER, true)"-->
<!--                />-->
<!--              </div>-->
            </div>
          </div>
        </a-col>
        </template>
        <wmsWarehouseMultiple
        v-else
        :type-index="typeIndex"
        @downloadExcelWareHouse="downloadExcelWareHouse"
        @downloadExcelWareHouseTransport="downloadExcelWareHouseTransport"
        @editTypeIndex="editTypeIndex"
        @downloadTemplate="downloadTemplate"
        @changeWareHouseType="changeType"
         />
      </a-row>
    </block-title>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import downloadField from '@/assets/img/icon/download_field.png'
import downloads from '@/assets/img/icon/download.png'
import { mapGetters } from 'vuex';
import {UsualToBusiness, WAREHOUSETYPE} from './multipleConst'
import wmsWarehouseMultiple from './wmsWarehouseMultiple/index.vue'

export default {
  name: 'WarehouseMultiple',
  components: {
    BlockTitle,
    wmsWarehouseMultiple,
  },
  props: {
    typeIndex: {
      type: String,
      default: ''
    },
    isDischarge: {
      type: Boolean,
      default: false,
    },
    isWmsSystem:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      WAREHOUSETYPE,
      downloadField,
      downloads,
      type: WAREHOUSETYPE.STORE_V2,
    }
  },
  watch: {
    typeIndex(newVal) {
      if(newVal === 'WAREHOUSE_TRANSPORT') {
        this.changeType(WAREHOUSETYPE.DELIVER_TRANSPORT_V2)
      }else {
        this.changeType(WAREHOUSETYPE.STORE_V2)
      }

    }
  },
  computed:{
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
  },
  methods: {
    downloadExcelWareHouse(item, type) {
      this.$emit('downloadExcelWareHouse', item, type)
    },
    downloadExcelWareHouseTransport(item, type) {
      this.$emit('downloadExcelWareHouseTransport', item, type)
    },
    editTypeIndex(index) {
      this.$emit('editTypeIndex', index)
    },
    downloadTemplate(item, type, isTransport) {
      const innerType = this.isOrderDemoVersion? type : (UsualToBusiness[type]||type)
      this.$emit('downloadTemplate', item, innerType, isTransport)
    },
    changeType(type) {
      this.type = type;
      this.$emit('changeWareHouseType', type)
    }
  }
}
</script>

<style lang="less" scoped>
.icon_load {
  width: 24px;
  height: 24px;
}
.radioBox {
  .justify-between {
    .batchBtn {
      background: #F2FBF8;
      border-radius: 4px;
      padding:10px;
      min-height: 68px;
      color: #06B880;
      border: 1px dashed #ebe8e8;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:last-of-type {
        margin-left: 10px;
      }
      &.no-left {
        margin-left: 0;
      }
      &:hover {
        border: 1px dashed #06B880;
      }
    }
  }
  &.radioBoxActive {
    .justify-between {
      .batchBtn {
        &.isActive {
          border: 1px dashed #06B880;
        }
      }
    }
  }
}
</style>
